import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import ScrollToTop from "src/components/ScrollToTop";

const Layout = () => {

  return (
    <div className="flex flex-col min-h-screen min-w-screen bg-white-1"> 
        <Navbar />
        <div className="my-auto">
            <Outlet />
        </div>
        <ScrollToTop />
        <Footer />
    </div>
  );
};

export default Layout;